import React, { useState } from "react";
import {
  postPartnerConsultationCallEngagement,
  postWarrantyLead,
} from "../../api";
import { useSelector } from "react-redux";

export default function GetStarted() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const partner = useSelector((state) => state.partnerState.partner);
  const user = useSelector((state) => state.userState.user);

  const onSubmit = (e) => {
    if (email.trim().length === 0) {
      setMessage("Please enter in an email address.");
      return;
    }
    setLoading(true);
    postWarrantyLead(email)
      .then(() => {
        setMessage(
          `You will be contacted by a Sunfish Financial Advocate shortly.`,
        );
        setEmail("");
        setLoading(false);
      })
      .catch((e) => {
        if (e?.message) {
          setMessage(e?.message);
        } else {
          setMessage(
            "Something went wrong, please reach out at support@joinsunfish.com",
          );
        }
        setEmail("");
        setLoading(false);
      });
  };

  return (
    <div className="flex flex-col justify-center items-center w-full sm:gap-0 lg:py-[72px] sm:py-0 bg-[#faf8e3] px-[24px]">
      <div className="flex flex-col justify-center items-center gap-2 pb-10">
        <p className="sm:pt-[32px] lg:pt-0 sm:pb-[24px] lg:pb-0 text-5xl font-bold text-center text-navyblue">
          Get Started
        </p>
        <p className="sm:pb-[32px] lg:pb-0 text-3xl font-light text-center text-navyblue">
          Learn more about this program and how it could work for you!
        </p>
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-1 lg:px-2 sm:px-0 content-center auto-rows-min grid-flow-dense	">
        <div className="flex flex-col justify-start items-center flex-grow relative lg:gap-6 sm:gap-0">
          <p className="sm:pb-[8px] lg:pb-0 text-xl text-center text-navyblue">
            <span className="font-semibold text-center">Set up a call </span>
            <span className="font-light text-center">with our team</span>
          </p>
          <a
            className="flex text-[14px] tracking-[0.28px] justify-start items-center relative gap-4 px-6 py-3 rounded-3xl bg-[#d89162] sm:w-full"
            href="https://calendly.com/joinsunfish/gold_program"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              if (partner && user) {
                postPartnerConsultationCallEngagement(
                  user.uid,
                  user.email,
                  partner.name,
                );
              }
            }}
          >
            <p className="text-[14px] font-bold text-center uppercase text-white mx-auto">
              Schedule a free call
            </p>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="flex-shrink-0 w-6 h-6 relative"
              preserveAspectRatio="none"
            >
              <g opacity="0.5">
                <path
                  d="M13.9134 3.45953C13.9906 3.17139 14.179 2.92568 14.4372 2.77642C14.6955 2.62716 15.0025 2.58658 15.2906 2.66359C16.7451 3.04249 18.0721 3.80252 19.1349 4.86529C20.1976 5.92806 20.9577 7.25509 21.3366 8.70953C21.3782 8.85331 21.3908 9.00397 21.3735 9.15266C21.3562 9.30136 21.3094 9.44511 21.2358 9.57549C21.1623 9.70587 21.0634 9.82026 20.9451 9.91195C20.8268 10.0036 20.6913 10.0708 20.5467 10.1095C20.4021 10.1482 20.2512 10.1576 20.1029 10.1372C19.9546 10.1168 19.8119 10.0671 19.683 9.99083C19.5542 9.91458 19.4419 9.81339 19.3527 9.69318C19.2634 9.57297 19.1991 9.43617 19.1634 9.29078C18.884 8.21941 18.324 7.24192 17.5411 6.45901C16.7582 5.67611 15.7807 5.11611 14.7094 4.83672C14.4212 4.75958 14.1755 4.57117 14.0263 4.31292C13.877 4.05466 13.8364 3.7477 13.9134 3.45953ZM22.1109 16.4608C21.9322 17.8217 21.2641 19.071 20.2316 19.9753C19.199 20.8797 17.8726 21.3773 16.5 21.3752C8.84906 21.3752 2.625 15.1511 2.625 7.50015C2.62287 6.12756 3.12046 4.80112 4.02482 3.76858C4.92918 2.73604 6.17847 2.06799 7.53937 1.88922C7.94036 1.84049 8.34637 1.92223 8.69726 2.12233C9.04815 2.32243 9.32525 2.63024 9.4875 3.00015L11.4666 7.41859C11.4687 7.42438 11.4712 7.43002 11.4741 7.43547C11.5957 7.71973 11.6451 8.02967 11.618 8.33767C11.5908 8.64567 11.4879 8.94217 11.3184 9.20078C11.2943 9.23846 11.2677 9.27448 11.2387 9.30859L9.45187 11.4377C10.1137 12.6414 11.3737 13.8902 12.5916 14.5511L14.6831 12.7698C14.7167 12.7417 14.7517 12.7154 14.7881 12.6911C15.0476 12.517 15.3467 12.4108 15.6579 12.3823C15.9692 12.3538 16.2826 12.4039 16.5694 12.528L16.5862 12.5355L21 14.5127C21.3698 14.675 21.6775 14.9521 21.8776 15.303C22.0777 15.6539 22.1595 16.0598 22.1109 16.4608ZM19.8319 16.4552L15.8944 14.6917L13.7916 16.4795C13.7585 16.5082 13.7238 16.5348 13.6875 16.5592C13.4172 16.7384 13.105 16.8445 12.7815 16.867C12.4579 16.8895 12.1341 16.8277 11.8416 16.6877C10.0153 15.8064 8.19562 13.9989 7.3125 12.1877C7.17206 11.8964 7.10931 11.5739 7.13033 11.2512C7.15136 10.9286 7.25545 10.6169 7.4325 10.3464C7.45694 10.3087 7.48388 10.2727 7.51312 10.2386L9.30937 8.10859L7.545 4.17109C6.78694 4.33815 6.10881 4.7594 5.62315 5.36495C5.13748 5.97049 4.87349 6.72391 4.875 7.50015C4.87872 10.5822 6.10469 13.5369 8.28399 15.7162C10.4633 17.8955 13.418 19.1214 16.5 19.1252C17.2767 19.1273 18.0308 18.8636 18.6369 18.3779C19.243 17.8922 19.6647 17.2137 19.8319 16.4552ZM13.6528 8.38797C14.1129 8.53298 14.5312 8.78679 14.8723 9.12788C15.2134 9.46897 15.4672 9.88728 15.6122 10.3473C15.684 10.5756 15.8267 10.775 16.0195 10.9166C16.2124 11.0583 16.4454 11.1347 16.6847 11.1348C16.7994 11.1347 16.9135 11.1173 17.0231 11.0833C17.3066 10.9936 17.543 10.7953 17.6808 10.5318C17.8185 10.2683 17.8463 9.96098 17.7581 9.67703C17.5044 8.8715 17.0601 8.13908 16.4629 7.5419C15.8658 6.94472 15.1333 6.50043 14.3278 6.24672C14.186 6.19915 14.0362 6.18032 13.8871 6.19133C13.738 6.20234 13.5925 6.24297 13.4593 6.31084C13.326 6.37872 13.2077 6.47248 13.1111 6.58664C13.0145 6.7008 12.9416 6.83307 12.8968 6.97571C12.8519 7.11836 12.8359 7.26852 12.8498 7.41741C12.8636 7.5663 12.907 7.71094 12.9774 7.84287C13.0478 7.9748 13.1438 8.09137 13.2597 8.18577C13.3757 8.28017 13.5093 8.3505 13.6528 8.39265V8.38797Z"
                  fill="white"
                ></path>
              </g>
            </svg>
          </a>
        </div>
        <div className="flex lg:flex-col sm:flex-row justify-center items-center flex-shrink-0  sm:py-[24px]">
          <svg
            width="118"
            height="1"
            viewBox="0 0 118 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="self-stretch flex-grow-0 flex-shrink-0 mt-3 px-2 lg:hidden sm:block"
            preserveAspectRatio="xMidYMid meet"
          >
            <line
              y1="0.5"
              x2="118"
              y2="0.5"
              stroke="#5870AF"
              stroke-opacity="0.3"
            ></line>
          </svg>

          <svg
            width="1"
            height="38"
            viewBox="0 0 1 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="flex-grow sm:hidden lg:block"
            preserveAspectRatio="xMidYMid meet"
          >
            <line
              x1="0.5"
              y1="2.18557e-8"
              x2="0.499998"
              y2="38"
              stroke="#5870AF"
              stroke-opacity="0.3"
            ></line>
          </svg>
          <p className="text-base text-center text-navyblue">or</p>
          <svg
            width="1"
            height="38"
            viewBox="0 0 1 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="flex-grow sm:hidden lg:block"
            preserveAspectRatio="xMidYMid meet"
          >
            <line
              x1="0.5"
              y1="2.18557e-8"
              x2="0.499998"
              y2="38"
              stroke="#5870AF"
              stroke-opacity="0.3"
            ></line>
          </svg>
          <svg
            width="118"
            height="1"
            viewBox="0 0 118 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="self-stretch flex-grow-0 flex-shrink-0 mt-3 px-2 lg:hidden sm:block"
            preserveAspectRatio="xMidYMid meet"
          >
            <line
              y1="0.5"
              x2="118"
              y2="0.5"
              stroke="#5870AF"
              stroke-opacity="0.3"
            ></line>
          </svg>
        </div>
        <div className="flex flex-col justify-start items-center flex-grow relative gap-6 sm:pb-[32px] lg:pb-0">
          <p className="text-xl font-semibold text-center text-navyblue">
            Send us an email
          </p>
          <div className="w-full flex justify-between items-center relative pl-6 rounded-3xl bg-white border border-[#e6e4cf]">
            <input
              type="email"
              className="w-full lg:pl-2 bg-transparent outline-none lg:w-72 sm:w-full"
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              aria-label="email-input-get-in-touch"
              value={email}
            />

            <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative px-6 py-3 rounded-[100px] bg-[#113165]">
              <p className="flex-grow-0 flex-shrink-0 text-base font-bold text-center uppercase text-white">
                <button
                  disabled={loading}
                  onClick={onSubmit}
                  className={
                    loading
                      ? "block ml-auto w-24 lg:w-16 bg-gray-500 text-white rounded-full"
                      : "block ml-auto w-24 lg:w-16 bg-navyblue text-white rounded-full"
                  }
                >
                  Submit
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
      {message ? <span>{message}</span> : null}
    </div>
  );
}
